<template>
  <div>
    <div
      v-if="isSoldOut == false"
      class="col-12 mb-4"
    >
      <template v-if="bookingStep == 1">
        <v-card>
          <v-card-text>
            <div class="row ticket-details">
              <div class="col-12 pb-0">
                <b>Моля въведете вашите данни:</b>
              </div>
              <div class="col-12 col-sm-4">
                <v-text-field
                  class="p-0 m-0"
                  v-model="client.name"
                  label="Име и Фамилия"
                ></v-text-field>
              </div>
              <div class="col-12 col-sm-4">
                <v-text-field
                  class="p-0 m-0"
                  v-model="client.email"
                  label="Email"
                ></v-text-field>
              </div>
              <div class="col-12 col-sm-4">
                <v-text-field
                  class="p-0 m-0"
                  v-model="client.phone"
                  label="Телефон за връзка"
                ></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-4">
                <v-select
                  :items="event.public_active_ticket_groups"
                  :value="selectedTicketsType"
                  @change="setSelectedTicketType"
                  item-text="title"
                  label="Избор на ценова категория"
                  return-object
                ></v-select>
              </div>
              <div
                class="col-12 col-sm-6"
                v-if="showTicketSelector"
              >
                <v-select
                  v-model="selectedTickets"
                  :items="maxTickets"
                  :label="
                    !selectedTicketsType || maxTickets.length > 0
                      ? 'Брой билети'
                      : 'Няма свободни билети в тази категория'
                  "
                  :disabled="maxTickets.length === 0"
                ></v-select>
              </div>
            </div>

            <div
              class="row"
              v-if="ticketsInfo"
            >
              <div class="col-12 text-center align-self-center">
                <v-alert
                  :value="true"
                  color="warning"
                  icon="priority_high"
                  outlined
                  class="alert-box"
                >
                  <!--                  In order to prevent unauthorized usage please fill the names of the people who will attend the event.-->
                  <!--                  If needed, the names can be changed on-site right before the performance.-->
                  За да предотвратите неоторизирано използване на билетите, моля
                  попълнете имената на хората, които ще присъстват на събитието.
                  При нужда имената могат да бъдат променени на място преди
                  събитието.
                </v-alert>
              </div>
              <div
                class="col-12 text-center align-self-center"
                v-if="ticketsInfo.length > 0"
              >
                Моля въведете тук имената на притежателя на билета
              </div>
              <template v-for="(ticket, index) in ticketsInfo">
                <div class="col-12 col-sm-6">
                  <b>
                    Билет #{{ index + 1 }},
                    <span v-if="ticketsPerGroup == 1">
                      Цена: {{ currencySign }}{{ selectedTicketTypePrice }}
                    </span>
                  </b>
                  <br />
                  <v-text-field
                    v-model="ticket.name"
                    label="Име и Фамилия"
                  ></v-text-field>
                </div>
              </template>
            </div>
            <div class="row">
              <div class="col">
                <tos-checkbox
                  :is-valid="isGdprValid"
                  @update-gdpr="(v) => (gdpr = v)"
                ></tos-checkbox>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6 align-self-center">
                <h5 class="price-total">
                  Общо: {{ currencySign }}{{ seatsTotal }}
                </h5>
              </div>
              <div class="col-6 justify-content-end text-right">
                <v-btn
                  class="primary"
                  @click="reserveSeats()"
                >
                  Продължи
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>
      <template v-if="bookingStep == 2">
        <Payment
          :selected-tickets="ticketsInfo"
          :event="event"
          :amount="seatsTotal"
          :secret="secret"
          :enable-borika="true"
          @gateway-change="reportMarketingEvent('initiate_checkout')"
        ></Payment>
      </template>
    </div>
    <div
      class="col-12 mb-4"
      v-else
    >
      <div class="mb-4">
        <v-card>
          <v-card-text>
            <div class="sold-out sold-out--ga">SOLD OUT</div>
          </v-card-text>
        </v-card>
      </div>
      <div class="mb-4">
        <EmailSubscription :event="event"></EmailSubscription>
      </div>
    </div>
  </div>
</template>
<script>
import Payment from './Payment'
import EmailSubscription from './EmailSubscription'
import TosCheckbox from './components/TosCheckbox'

export default {
  name: 'GeneralAdmission',
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  components: {
    Payment,
    EmailSubscription,
    TosCheckbox,
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    seatsTotal() {
      let sum = 0

      if (this.selectedTickets) {
        // When the group generates more than 1 ticket
        let ticket_multiplier = 1

        if (this.selectedTicketsTypeObject.generated_per_ticket) {
          ticket_multiplier =
            this.selectedTicketsTypeObject.generated_per_ticket
        }

        this.event.public_active_ticket_groups.forEach((item, index) => {
          if (this.selectedTicketsType == item.title) {
            sum = this.selectedTickets * item.price * ticket_multiplier
          }
        })
      }

      return sum
    },
    maxTickets() {
      if (this.selectedTicketsType !== null) {
        let max = Number(
          this.selectedTicketsTypeObject.limit > 10
            ? 10
            : this.selectedTicketsTypeObject.limit
        )

        if (max > this.event.available_tickets[this.selectedTicketsTypeIndex]) {
          max = this.event.available_tickets[this.selectedTicketsTypeIndex]
        }

        if (this.event.available_tickets[this.selectedTicketsTypeIndex] < 0) {
          max = 0
        }

        return Array.from(Array(max).keys(), (n) => n + 1)
      }
      return []
    },
    ticketsTypes() {
      const types = []
      this.event.public_active_ticket_groups.forEach((item, index) => {
        if (this.event.available_tickets[index]) {
          types.push(item.title)
        }
      })
      return types
    },
    isSoldOut() {
      return (
        this.event.available_tickets_total == 0 ||
        this.event.status == 2 || // Sold out status
        this.event.status == 3 // Not on sale status
      )
    },
    currencySign() {
      if (this.event.decoded_settings.currency === 'BGN') {
        return 'BGN'
      }
      if (this.event.decoded_settings.currency === 'GBP') {
        return '£'
      }
      if (this.event.decoded_settings.currency === 'USD') {
        return '$'
      }
      return '€'
    },
    showTicketSelector() {
      return (
        this.selectedTicketsTypeObject &&
        (!this.selectedTicketsTypeObject.generated_per_ticket ||
          this.selectedTicketsTypeObject.generated_per_ticket == 1)
      )
    },
    ticketsPerGroup() {
      if (
        this.selectedTicketsTypeObject &&
        this.selectedTicketsTypeObject.generated_per_ticket
      ) {
        return this.selectedTicketsTypeObject.generated_per_ticket
      }

      return 1
    },
  },
  data() {
    return {
      gdpr: false,
      isGdprValid: true,
      bookingStep: 1,
      tickets: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      selectedTickets: null,
      selectedTicketsType: null,
      selectedTicketTypePrice: 0,
      selectedTicketsTypeObject: {}, // Use this to refactor at some point
      selectedTicketsTypeIndex: null,
      ticketsInfo: [],
      client: {
        name: '',
        email: '',
        phone: '',
      },
      secret: '',
      initiate_checkout_reported: false,
    }
  },
  watch: {
    selectedTickets(newVal, oldVal) {
      if (newVal > oldVal) {
        for (let i = 0; i < newVal - oldVal; i++) {
          this.ticketsInfo.push({
            name: '',
            email: '',
            phone: '',
          })
        }
      } else if (newVal < oldVal) {
        for (let i = 0; i < oldVal - newVal; i++) {
          this.ticketsInfo.splice(-1, 1)
        }
      }
    },
    bookingStep(val) {
      if (val == 2) {
        this.reportMarketingEvent('ticket_type_selected')
      }
    },
  },
  methods: {
    reportMarketingEvent(event) {
      const data = {
        event: event,
        event_data: {
          name: this.client.name,
          email: this.client.email,
          phone: this.client.phone,
          ticket_type: this.selectedTicketsTypeObject.title,
          ticket_count: this.selectedTickets,
          value: this.seatsTotal,
        },
      }

      if (event == 'ticket_type_selected') {
        axios
          .post(`/reporting/add-to-cart/${this.event.uuid}`, data)
          .then((response) => {
            let fb = response.data
            console.log(fb)
            fbq(
              'track',
              'AddToCart',
              {
                fbp: fb.user_data.fbp,
                fbc: fb.user_data.fbc,
                em: fb.user_data.em[0],
                ph: fb.user_data.ph[0],
                fn: fb.user_data.fn,
                ln: fb.user_data.ln,
                currency: 'EUR', //fb.custom_data.currency
                value: fb.custom_data.value,
                content_type: 'product',
                content_ids: [this.event.uuid],
                country: fb.user_data.country,
              },
              {
                eventID: fb.event_id,
              }
            )
          })
      } else if (
        event == 'initiate_checkout' &&
        !this.initiate_checkout_reported
      ) {
        axios
          .post(`/reporting/initiate-checkout/${this.event.uuid}`, data)
          .then((response) => {
            let fb = response.data
            console.log(fb)
            fbq(
              'track',
              'InitiateCheckout',
              {
                fbp: fb.user_data.fbp,
                fbc: fb.user_data.fbc,
                em: fb.user_data.em[0],
                ph: fb.user_data.ph[0],
                fn: fb.user_data.fn,
                ln: fb.user_data.ln,
                currency: 'EUR', //fb.custom_data.currency
                value: fb.custom_data.value,
                content_type: 'product',
                content_ids: [this.event.uuid],
                country: fb.user_data.country,
              },
              {
                eventID: fb.event_id,
              }
            )
          })
        this.initiate_checkout_reported = true
      }
    },
    reserveSeats() {
      let error = false

      this.payBtnDisabled = true

      if (!this.gdpr) {
        alert('Моля съгласете се с общите условия')
        this.isGdprValid = false
        this.payBtnDisabled = false
        return
      }

      if (this.selectedTickets == null) {
        alert('Моля изберете брой билети')
        return
      }

      if (this.client.name.length < 3) {
        error = {
          error: true,
          reason: 'Полето `Име` е задължително',
        }
      }

      if (this.client.email.length < 3) {
        error = {
          error: true,
          reason: 'Полето Email е задължително',
        }
      }

      if (this.selectedTickets == null || this.selectedTickets == 0) {
        alert('Моля изберете брой билети')
        return
      }

      this.ticketsInfo.forEach((item) => {
        if (typeof item.name === 'undefined' || item.name.length < 3) {
          error = {
            error: true,
            reason: 'Моля попълнете всички полета!',
          }
        }
      })

      if (error) {
        this.error = error
        alert(error.reason)
        this.payBtnDisabled = false
        return
      }

      const data = {
        client: this.client,
        index_friendly: this.selectedTicketsType,
        index: this.selectedTicketsTypeIndex,
        seats: this.ticketsInfo,
      }
      axios
        .post(`/event/${this.event.id}/ticket/ga`, data)
        .then((response) => {
          this.secret = response.data.secret
          this.bookingStep = 2
        })
        .catch((error) => {
          alert(error.response.data.message)
        })
    },
    setSelectedTicketType(o) {
      this.selectedTicketsTypeIndex = o.id
      this.selectedTicketsType = o.title
      this.selectedTicketTypePrice = o.price
      this.selectedTicketsTypeObject = o

      if (this.maxTickets.length > 0) {
        this.selectedTickets = 1
      } else {
        this.selectedTickets = 0
      }
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
.sold-out.sold-out--ga {
  position: static;
  line-height: 2;
}

.alert-box {
  color: white !important;

  .v-icon {
    align-self: center;
    color: white;
  }
}

.small-text {
  font-size: 11px;
  line-height: 1.2em;
}
</style>
